import { useMutation } from '@tanstack/react-query';
import { changePassword } from '../services/auth_service';

const useChangePassword = () => {
    const changePasswordMutation = useMutation({
        mutationFn: changePassword,
        onSuccess: (data) => {
        },
        onError: (error) => {
            console.error('Error changing password:', error);
        }
    });
    
    return changePasswordMutation;
}

export default useChangePassword; 